import { Component } from '@angular/core';
import { LegalLayoutComponent } from '../components/legal-layout.component';

@Component({
  selector: 'app-faq',
  standalone: true,
  imports: [LegalLayoutComponent],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.css'
})
export class FaqComponent {
  title = 'Preguntas Frecuentes';
  lastUpdated = '30 de octubre de 2025';
}

